module.exports = {
  Ordering: {
    PluginName: "Ordering",
    content_box_name: "Content ",
    Statement:
      "This is a sorting question that includes correct sorting of answers. Here you can write the question phrase",
    Question: "Question",
    Feedback: "Feedback",
    FeedbackMsg:
      "Here you can provide some feedback about the answer. In order to disable this feature, turn it off in the toolbar.",
    TrueFeedbackMsg:
      "Here you can provide some feedback about the true answer. In order to disable this feature, turn it off in the toolbar.",
    FalseFeedbackMsg:
      "Here you can provide some feedback about the false answer. In order to disable this feature, turn it off in the toolbar.",
    ShowFeedback: "Show Feedback Msg.",
    ShowStars: "Show stars instead of numbers",
    background_color: "Background color",
    border_color: "Border Color",
    border_size: "Border Size",
    border_style: "Border Style",
    box_style: "Box Style",
    opacity: "Opacity",
    padding: "Padding",
    pos: "Position",
    radius: "Radius",
    source: "Source",
    Answer: "Answer",
    Number: "Number of Levels",
    Color: "Color",
    tryAgain: "Try Again",
    checkAnswer: "Check Answer",
    notCount: "This exercise does not add points",

    Matching: {
      PluginName: "Matching",
      content_box_name: "Content ",
      Statement:
        "This is a Multiple Choice question with a single correct answer. You can write here the question statement",
      Question: "Question",
      Feedback: "Feedback",
      FeedbackMsg:
        "Here you can provide some feedback about the answer. In order to disable this feature, turn it off in the toolbar.",
      TrueFeedbackMsg:
        "Here you can provide some feedback about the true answer. In order to disable this feature, turn it off in the toolbar.",
      FalseFeedbackMsg:
        "Here you can provide some feedback about the false answer. In order to disable this feature, turn it off in the toolbar.",
      ShowFeedback: "Show feedback msg.",
      Number: "Number  of answers",
      ShowLettersInsteadOfNumbers: "Show letters instead of numbers",
      background_color: "Background color",
      border_color: "Border color",
      border_size: "Border Size",
      border_style: "Border Style",
      box_style: "Box style",
      opacity: "Opacity",
      padding: "Padding",
      pos: "Position",
      radius: "Radius",
      source: "Source",
      Answer: "Answer",
      Number: "Number",
      Color: "Color",
      Correct: "Correct",
      tryAgain: "Try Again",
      checkAnswer: "Check Answer",
    },
  },
};
